// ======== plugin import ========= //
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { notification } from 'antd';
import Swal from 'sweetalert2';
import { useParams } from "react-router-dom";
// ========== module import ========= //

// ======== component import =========== //
import NoDataFound from '../../../../component/common/NoDataFound'
import AgentListTable from './AgentListTable'
import Pagination from '../../../../component/common/pagination/Pagination'
import { MenuComponent } from '../../../../../_template/assets/ts/components/MenuComponent';

const AgentList = (props) => {
    const [api, contextHolder] = notification.useNotification();
    const { agentSearchState, isFormSubmited } = props;
    const { company } = useParams();
    const loginUserType = localStorage.getItem('type');

    const api_base_url = process.env.REACT_APP_API_URL;

    const [ agentUpdateId , setAgentUpdateId] = useState('');
    const [page, setPage] = useState(1);
    const dataLimit = 50;

    const [paginationData, setPaginationData] = useState({})
    const [ agentData, setAgentData ] = useState([]);

    const getAgentlistData = async () => {
        let apiToken = '';
        if(loginUserType === 'A') {
            apiToken = localStorage.getItem('token')
        } else if(loginUserType === 'D') {
            apiToken = localStorage.getItem('developertoken')
        } else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }

        var api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };

        var data = {
            searchData : agentSearchState,
            page : page,
            limit : dataLimit,
            agent_update_id: agentUpdateId,
            sass_id: localStorage.getItem('sass_id')
        }

        await axios.post(`${api_base_url}admin/get-agent-list`, data, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                if(agentUpdateId === ''){
                    setAgentData(res.data.data.agent_data);
                    setPaginationData({
                        current_pages : res.data.data.current_pages,
                        total_data_count : res.data.data.total_count,
                        total_pages : res.data.data.total_pages,
                        limit : res.data.data.limit,
                        data_length : res.data.data.agent_data.length
                    });
                    props.refreshSuccess();
                    props.totalAgentCount(res.data.data.total_count);
                    //if(isFormSubmited) {
                        MenuComponent.reinitialization();
                    //}
                }
                else{
                    var agentUpdateData = res.data.data.agent_data[0];
                    props.agentUpdateData(agentUpdateData)
                    setAgentUpdateId('')
                }
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    useEffect(() => {
        getAgentlistData();
    },[agentSearchState, isFormSubmited, setPage, agentUpdateId])

    const statusChangeHandler = async (username, value) => {
        let apiToken = '';
        if(loginUserType === 'A') {
            apiToken = localStorage.getItem('token')
        } else if(loginUserType === 'D') {
            apiToken = localStorage.getItem('developertoken')
        } else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }

        var api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        var data = {
            user_name : username,
            status : value ? 'Y' : 'N',
            sass_id: localStorage.getItem('sass_id')
        }

        await axios.post(`${api_base_url}api/update-system-user-active-status`, data, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                api["success"]({
                    message: 'Success',
                    description: res.data.message
                });
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    const agentDeleteHandler = async (param) =>{
       
        const agentDeleteSwal = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won’t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
        if (agentDeleteSwal.isConfirmed) {
            let apiToken = '';
            if(loginUserType === 'A') {
                apiToken = localStorage.getItem('token')
            } else if(loginUserType === 'D') {
                apiToken = localStorage.getItem('developertoken')
            } else if(loginUserType === 'SA') {
                apiToken = localStorage.getItem('systemAdminToken')
            }

            param.sass_id = localStorage.getItem('sass_id');

            var api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token": apiToken
                }
            };
            await axios.post(`${api_base_url}admin/agent-delete`, param, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    api["success"]({
                        message: 'Success',
                        description: res.data.message
                    });
                    getAgentlistData();
                } else if(res.data.status === 'error') {
                    console.error('error')
                }
            })
            .catch((error) => {
                console.error(error);
            }) 
        }
    }

    const agentUpdateHandler = (agentUpdateId) => {
        setAgentUpdateId(agentUpdateId);
        props.editButtonClick();
    }
    // ------- set agent data ------- //
    let agentHtml = (
        <tr>
            <td colSpan="4" className="text-center">
                <NoDataFound className="w-30" setHtml="No agent found" />
            </td>
        </tr>
    )
 
    if(agentData.length > 0){
        agentHtml = agentData.map((agent) => 
            <AgentListTable
                key={agent.unique_id}
                agent_full_name ={agent.agent_full_name}
                agent_email ={agent.agent_email}
                active_status ={agent.active_status}
                channel_data ={agent.channel_data}
                bot_data ={agent.bot_data} 
                password ={agent.password} 
                username ={agent.username} 
                unique_id ={agent.unique_id} 
                statusOnChange={statusChangeHandler}
                agentDeleteOnClick = {agentDeleteHandler}
                agentUpdateOnClick  = {agentUpdateHandler}
            />
        )
    }
    // ------- pagination ----- //
    const pagechangeHandler = (pageNumber, type) => {
        if( type === 'previous' ){
            setPage((c_page) => c_page - 1)
        }else if( type === 'page' ){
            setPage(pageNumber)
        }
        else if( type === 'next' ){
            setPage((c_page) => c_page + 1)
        }
    }

  
    // useEffect(() => {
    //     setTimeout(() => {
    //         MenuComponent.reinitialization();
    //     }, 500);
    // }, []);

    return (
        <>
            <div className="row mt-5">
                <div className="col-md-12">
                    <div className="card border">
                        <div className="card-body py-4">
                            <div id="sai_table_users_wrapper" className="dataTables dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                                                <th className="w-300px sorting">Name</th>
                                                <th className="w-300px sorting">Activity</th>
                                                <th className="w-250px sorting">Allowed Bot</th>
                                                <th className="w-250px sorting">Allowed Channel</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold set-system-user-list">
                                            {agentHtml}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {agentData.length > 0 && 
                <Pagination
                    pagination_data={paginationData}
                    onClick={pagechangeHandler}
                />
            } 
            {contextHolder}           
        </>
    )
}

export default AgentList